module.exports = __webpack_public_path__ + "static/1312604977.b31eccf6.jpg";